<script>
import AddressLadSelector from "@/containers/adresses-lad/adress-lad-selector";
import Planning from "@/containers/planning";
import ShippingMethodPhone from "@/containers/shipping-method/shipping-method-phone";
import AbonnementLadEuroDePlus from "@/containers/abonnement-lad/euro-de-plus";
import ChoixSacDrive from "@/components/organisms/choix-sac-drive";

import { shippingMethodLadProps, useShippingMethodLad } from "./mixin";

export default {
  name: "ShippingMethodLad",
  components: {
    AddressLadSelector,
    Planning,
    ShippingMethodPhone,
    AbonnementLadEuroDePlus,
    ChoixSacDrive
  },
  props: {
    ...shippingMethodLadProps()
  },
  setup(props) {
    const { abonnementInCurrentMagasin, showBanniereEuroPlus, montantSac } =
      useShippingMethodLad(props);
    return { abonnementInCurrentMagasin, showBanniereEuroPlus, montantSac };
  },
  data() {
    return {
      error: null
    };
  }
};
</script>

<template>
  <div>
    <div
      v-if="showBanniereEuroPlus"
      class="u-pt-md u-px-md u-pb-lg"
    >
      <AbonnementLadEuroDePlus :frais-livraison="tarifLad" />
    </div>

    <ChoixSacDrive
      v-if="consigneSacs"
      :is-offert="isSacOffert"
      :montant-sac="montantSac"
      class="u-px-md"
    />

    <AddressLadSelector />

    <template v-if="addresseLad">
      <ShippingMethodPhone
        v-if="eligibleAlerteSms"
        :error="error"
        is-lad
      />
      <div class="u-px-sm u-mb-md">
        <p class="u-flex u-mb-xs u-font-20 u-font-secondary">
          <strong>Créneau horaire</strong>
        </p>
        <p>
          Merci de choisir un créneau horaire de livraison
        </p>
      </div>
      <Planning
        :service-id="service.id"
        :code-postal="addresseLad.attributes.code_postal"
        :code-insee="addresseLad.attributes.code_insee"
        :infos-legales="service.info_non_retrait"
        @error="(err) => {error = err}"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/shipping-address-mobile.scss";
</style>
